import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import MenuCM from "components/shared/menu";
import ProfileMenuCM from "components/profilemenu";
import FooterCM from "components/shared/footer";
import { Button } from "@mui/material";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import CardContent from "@mui/material/CardContent";
import { StyledCardContent } from "./Profile.style";
import { getUserInfoRequest, updateNormalUserRequest } from "api/requests";
import useHttp from "hooks/use-http";
import LoadingCM from "components/shared/Loading";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import AccountCircle from "@mui/icons-material/AccountCircle";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { editNormalUserSchema } from "validations";
import Toast from "helper/toast";
import CheckIcon from "@mui/icons-material/Check";
import ContactCM from "components/contactus";
import {
  FaPhoneSquare,
  FaLocationArrow,
  FaSearchLocation,
} from "react-icons/fa";
import { GrMapLocation } from "react-icons/gr";
import { AiOutlineBarcode, AiFillMail } from "react-icons/ai";
import {Helmet} from "react-helmet";

////////////////////////////
const formList = [
  {
    label: "تلفن همراه",
    type: "phone_number",
    id: "phone_number",
    icon: <FaPhoneSquare />,
    readOnly: true,
  },
  {
    label: "نام و نام خانوادگی",
    type: "text",
    id: "full_name",
    icon: <AccountCircle />,
    required: true,
    readOnly: false,
  },
  {
    label: "ایمیل",
    type: "email",
    id: "email",
    icon: <AiFillMail />,
    readOnly: false,
  },
];

export default function LoginColleague() {
  const { request, loading } = useHttp();
  const [user, setUser] = useState(0);
  const {
    register,
    handleSubmit,
    reset,
    getValues,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(editNormalUserSchema),
  });

  //////////////// FORM ////////////////
  const onSubmit = async (values) => {
    const res = await request({
      url: updateNormalUserRequest,
      values,
    });

    if (res) {
      Toast({
        type: "success",
        title: "ویرایش اطلاعات",
      });
    }
  };

  const getUserInfo = useCallback(async () => {
    const res = await request({
      url: getUserInfoRequest,
    });
    if (res) {
      reset({
        full_name: res.full_name,
        phone_number: res.phone_number,
        email: res.email,
      });
      setUser(res);
    }
  }, [request]);

  useEffect(() => {
    getUserInfo();
  }, []);

  ////////////////////////////
  const formListcolleague = [
    {
      label: "نام و نام خانوادگی",
      icon: <AccountCircle />,
      value: user.full_name,
      id: "name",
    },
    {
      label: "تلفن همراه",
      icon: <FaPhoneSquare />,
      value: user.phone_number,
    },
    {
      label: "ایمیل",
      icon: <AiFillMail />,
      value: user.email,
    },
  ];

  return (
    <>
      {loading && <LoadingCM />}
      <Helmet>
        <title>حساب کاربری - مبلمان ویول</title>
        <meta name="product_id" content={""} />
        <meta name="product_name" content={""} />
        <meta name="product_price" content={""} />
        <meta name="product_old_price" content={""} />
        <meta name="availability" content={""} />
        <meta property="og:image" content={""} />
      </Helmet>
      <MenuCM Background pageTitle="اطلاعات حساب" />
      <Container>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={3} lg={3}>
            <ProfileMenuCM />
          </Grid>
          <Grid item xs={12} sm={12} md={9} lg={9} mb={10}>
            <Paper p={2}>
              <StyledCardContent>
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: "21px",
                  }}
                >
                  اطلاعات حساب
                </Typography>
              </StyledCardContent>
              <CardContent>
                {user.type == "colleague" ? (
                  <Grid container spacing={3}>
                    {formListcolleague.map((items, index) => (
                      <Grid
                        item
                        sm={items.id == "name" ? 12 : 6}
                        xs={12}
                        key={index}
                      >
                        <FormControl fullWidth variant="standard">
                          <InputLabel>{items.label}</InputLabel>
                          <Input
                            value={items.value}
                            readOnly={true}
                            startAdornment={
                              <InputAdornment position="start">
                                {items.icon}
                              </InputAdornment>
                            }
                          />
                        </FormControl>
                      </Grid>
                    ))}
                  </Grid>
                ) : (
                  " "
                )}

                {user.type == "user" ? (
                  <Grid container spacing={3}>
                    {formList.map((items, index) => (
                      <Grid
                        item
                        md={items.id == "phone_number" ? 12 : 6}
                        xs={12}
                        p={1.5}
                        key={"profile" + index}
                      >
                        <FormControl fullWidth variant="standard">
                          <InputLabel>{items.label}</InputLabel>
                          <Input
                            id={items.id}
                            label={items.label}
                            variant="outlined"
                            required={items.required}
                            fullWidth
                            {...register(items.id)}
                            readOnly={items.readOnly}
                            error={Boolean(errors[items.id])}
                            startAdornment={
                              <InputAdornment position="start">
                                {items.icon}
                              </InputAdornment>
                            }
                          />
                          <FormHelperText id={items.id}>
                            {errors[items.id]?.message}
                          </FormHelperText>
                        </FormControl>
                      </Grid>
                    ))}
                    <Grid
                      item
                      md={12}
                      xs={12}
                      style={{ direction: "ltr", paddingTop: "0px" }}
                    >
                      <Button
                        color="success"
                        startIcon={<CheckIcon />}
                        variant="contained"
                        sx={{ mt: 1, mr: 1 }}
                        onClick={handleSubmit(onSubmit)}
                        style={{ direction: "rtl" }}
                      >
                        ویرایش
                      </Button>
                    </Grid>
                  </Grid>
                ) : (
                  ""
                )}
              </CardContent>
            </Paper>
          </Grid>
        </Grid>
      </Container>
      <ContactCM All />
      <FooterCM />
    </>
  );
}
